/**
 * Created by Дмитрий on 22.04.2019.
 */
import Api from "./api";

class BuyingService {
    api = new Api()

    getBuying(id, type) {
        return this.api.get('/buyer/buying/get-buying', {
            id: id,
            type: type
        })
    }

    getSellerBuying(id, type) {
        return this.api.get('/seller/buying/get-buying', {
            id: id,
            type: type
        })
    }

    addToBuying(ancestorId, attributes, count) {
        return this.api.post('/buyer/buying/add-to-cart', {
            ancestorId: ancestorId,
            attributeValues: attributes,
            count: count
        });
    }

    search(searchText) {
        return this.api.post('/seller/buyings-search/buyings', {
            text: searchText
        });
    }

    searchBuyer(searchText) {
        return this.api.post('/buyer/all/buyings', {
            text: searchText
        });
    }

    joinToBuying(buyingId, buyingType, buyingItemId, count) {
        return this.api.post('/buyer/buying/join-to-buying', {
            buyingId: buyingId,
            buyingType: buyingType,
            buyingItemId: buyingItemId,
            count: count
        })
    }

    getRequests() {
        return this.api.post('/buyer/request/get-requests');
    }

    repeatRequestAsBuying(items) {
        return this.api.post('/buyer/buying/repeat-request',{
            items: items
        })
    }

    updateCount(data) {
        return this.api.post('/buyer/buying/update-count', data);
    }


    getBuyingUserFilter(buyingId = null) {
        return this.api.get('/catalog/buying/get-buying-user-filter', {
            buyingId: buyingId
        });
    }

    setBuyingUserFilter(buyingId, filter) {
        return this.api.post('/catalog/buying/set-buying-user-filter', {
            buyingId: buyingId,
            filter: filter
        });
    }

    makeOffer(buyingId, type, offers) {
        return this.api.post('/seller/buying/make-offer', {
            buying: buyingId,
            type: type,
            offers: offers
        })
    }
}

export default new BuyingService();